import React from 'react';
import EndorsementItem from './EndorsementItem';
import EndorsementItemPending from './EndorsementItemPending';

export const EndorsementsList = (props) => {
    const { data, buttonHandlers } = props;
    return (
        <div className="list-endorsement">
            <h3 className="h3 category-name">{ data.title }</h3>
            { data.data.length === 0
                ?  <em>{ data.placeholder }</em>
                   : data && data.data.map( endorsement =>
                        data.title === "Pending"
                            ? <EndorsementItemPending
                                key={ endorsement.body.id  } { ...endorsement } { ...buttonHandlers } />
                            : <EndorsementItem
                                key={ endorsement.body.id  } { ...endorsement } { ...buttonHandlers } hideDeleteButton={ data.hideDeleteButton } />
                )
            }
        </div>
    )
};


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/endorsements/EndorsementsList.js